/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import L from "../Lang";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class LifecycleDash extends BaseCom {
    componentDidMount() {
        qreq.get('/api/phase/list/total', j => {
            this.setState({
                phases: Array.isArray(j?.list) ? j.list : [],
                phasesUnavailable: !Array.isArray(j?.list)
            });
        });
    }

    openPhase = phase => {
        const path = phase.isFinal
            ? '/order/discharge'
            : '/order/filter/' + window.btoa(JSON.stringify({ PhaseID: String(phase.id) }));
        this.props.navigate(path);
    };

    render() {
        const { phases, phasesUnavailable } = this.state;

        return <section className="LifecycleDash dashboard-panel" aria-label="Patient lifecycle"
            style={{ background: '#fff', border: '1px solid #e0e8ee', borderRadius: 12, minWidth: 0 }}>
            <div className="card-header">
                <h3 className="dashboard-panel-title"><L>Patient Lifecycle</L></h3>
            </div>
            <div className="card-body">
                {!phases && <div className="dashboard-widget-state" role="status"><L>Loading phases…</L></div>}
                {phasesUnavailable && <div className="dashboard-widget-state" role="status"><L>Lifecycle data unavailable.</L></div>}
                {phases && !phasesUnavailable && phases.length === 0 &&
                    <div className="dashboard-widget-state"><L>No lifecycle phases available.</L></div>}
                {phases?.length > 0 && <>
                    <p className="small mb-3" style={{ color: 'var(--dash-muted, #657888)' }}>
                        <L>Select a phase to view its orders.</L>
                    </p>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 160px), 1fr))', gap: 12 }}>
                        {phases.map(phase => <button
                            key={phase.id}
                            type="button"
                            className="btn text-start h-100"
                            onClick={() => this.openPhase(phase)}
                            style={{
                                display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                                gap: 12, minWidth: 0, padding: '18px 20px', borderRadius: 8,
                                background: '#f6f9fc', color: 'var(--dash-ink, #19364a)',
                                border: '1px solid #e2ebf1',
                                borderTop: `3px solid ${phase.color || '#22577a'}`,
                                whiteSpace: 'normal', overflowWrap: 'anywhere'
                            }}>
                            <span style={{ fontSize: '.85rem', fontWeight: 600 }}>{phase.name}</span>
                            <span style={{
                                fontSize: '2rem', fontWeight: 700, lineHeight: 1.15,
                                letterSpacing: '-.04em', fontVariantNumeric: 'tabular-nums',
                                color: 'var(--dash-blue, #22577a)'
                            }}>{phase.totalCount ?? 0}</span>
                            <span className="small" style={{ color: 'var(--dash-muted, #657888)', marginTop: 'auto' }}>
                                {phase.isFinal ? <L>View discharges</L> : <L>View orders</L>}
                                <span className="ms-2" aria-hidden="true">→</span>
                            </span>
                        </button>)}
                    </div>
                </>}
            </div>
        </section>;
    }
}

export default withParamsAndNavigate(LifecycleDash);
